import React, { useState, useEffect } from "react";
import { environment } from "./../../environment";
import TopBannerCarouselItem from "./TopBannerCarouselItem";

function TopBannerCarousel(params) {
    if (window.origin.includes(environment.localhost) || window.origin.includes(environment.devName)) {
        console.log('TopBannerCarousel')
        console.log(params)
    }

    let autoTime = (params.block['en']['RotationTime']) ? parseFloat(params.block['en']['RotationTime']) : 5000,
        headerOne = params.block['en'].hasOwnProperty('HeaderOne') ? params.block['en']['HeaderOne'] : '',
        Smaller = params.block['en'].hasOwnProperty('Smaller') ? (params.block['en']['Smaller'] === true ? ' smaller' : '') : '';
    const   [active, setActive] = useState(0),
            [activeLegalNote, setActiveLegalNote] = useState('');

    useEffect(() => {
        if (activeLegalNote.length > 0) {
            if (activeLegalNote === 'active') {
                autoTime = 50000000;
            }
            if (activeLegalNote === 'closed') {
                autoTime = (params.block['en']['RotationTime']) ? parseFloat(params.block['en']['RotationTime']) : 5000;
            }
        }
        const timer = setTimeout(() => changesStageNext(), autoTime);

        return () => {
            clearTimeout(timer);
        };
    });

    function changesStageNext() {
        setActive(active + 1);
        if (active + 1 > params.block['en']['Slide'].length - 1) {
            setActive(0);
        }
    }
    function changesStageBack() {
        setActive(active - 1);
        if (active - 1 < 0) {
            setActive(params.block['en']['Slide'].length - 1);
        }
    }

    let numberSlider = params.block['en']['Slide'].length;
    let innerSection = 'top-banner-carousel' + Smaller;
    let innerContainer = 'container';
    return (
        <section aria-roledescription="carousel" className={innerSection}>
            <div className="wrapper">
                <div className={innerContainer}>
                    <div className="w-100">
                        <div className="main-box d-flex">
                            {headerOne && 
                                <h1 className="header-one">
                                    {headerOne}
                                </h1>
                            }
                            <div className="d-flex w-100 item active">
                                <div className="item-main-box d-flex ai-center w-50 image">
                                    <div className="container text-box-inner">
                                        {params.block['en'].hasOwnProperty('Slide') && 
                                            Object.keys(params.block['en']['Slide']).map((slider, i) => (
                                                <TopBannerCarouselItem
                                                    key={'TopBannerCarouselItem-' + i}
                                                    block={params.block['en']['Slide'][slider]}
                                                    line={params.line}
                                                    typeItem="content"
                                                    classActive={active === i ? true : false}
                                                    legalNote={setActiveLegalNote}
                                                />
                                            ))
                                        }
                                        {numberSlider > 1 &&
                                            <div className="nav-carousel d-flex ai-center mt-30" role="navigation" aria-label="Carousel navigation">
                                                <button
                                                    type="button"
                                                    className="back mr-20"
                                                    aria-label="Previous slide"
                                                    onClick={changesStageBack}
                                                />
                                                {params.block.en?.Slide &&
                                                    Object.keys(params.block.en.Slide).map((slider, i) => (
                                                        <button
                                                            key={`stage-${i}`}
                                                            type="button"
                                                            className={`circle-stage ${active === i ? "active" : ""}`}
                                                            aria-label={`Go to slide ${i + 1}`}
                                                            aria-current={active === i ? "true" : undefined}
                                                            onClick={() => setActive(i)}
                                                        />
                                                    ))
                                                }
                                                <button
                                                    type="button"
                                                    className="next ml-20"
                                                    aria-label="Next slide"
                                                    onClick={changesStageNext}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="w-50 image r-side">
                                    {params.block['en'].hasOwnProperty('Slide') && 
                                        Object.keys(params.block['en']['Slide']).map((slider, i) => (
                                            <TopBannerCarouselItem
                                                key={'TopBannerCarouselItemImg-' + i}
                                                block={params.block['en']['Slide'][slider]}
                                                line={params.line}
                                                typeItem="image"
                                                classActive={active === i ? true : false}
                                            />
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TopBannerCarousel;